import { AxiosResponse } from 'axios';
import Api from '../api';
import { ModuleType } from '../modules.types';

const DeactivateApi = ({
  moduleType,
  id,
}: {
  moduleType: ModuleType;
  id: number;
}): Promise<AxiosResponse> => {
  const path = `/admin/${moduleType}/deactivate/${id}`;
  return Api.getInstance().request.put(path, {});
};
export default DeactivateApi;
